/** Water sheet: sky colour and alpha from time of day. Shade is drawn in world space. */
export const WATER_FRAGMENT = `
#pragma phaserTemplate(shaderName)

#ifdef GL_FRAGMENT_PRECISION_HIGH
precision highp float;
#else
precision mediump float;
#endif

uniform vec3 uDayColor;
uniform vec3 uNightColor;
uniform float uDayAlpha;
uniform float uNightAlpha;
uniform float uDaylight;

void main ()
{
    vec3 color = mix(uNightColor, uDayColor, uDaylight);
    float alpha = mix(uNightAlpha, uDayAlpha, uDaylight);
    gl_FragColor = vec4(color, alpha);
}
`;
